const formatNumberGroups = (numStr: string): string =>
  numStr.split(/(?=(?:...)*$)/).join(' ');

interface IFormatNumToAmountParams {
  num: number;
  showCents?: boolean;
  numberOfDecimalPlaces: number;
}

export const formatNumToAmount = ({
  num,
  showCents = true,
  numberOfDecimalPlaces
}: IFormatNumToAmountParams): string => {
  if (showCents || numberOfDecimalPlaces !== 2) {
    const parts = num.toFixed(numberOfDecimalPlaces).split('.');
    const delimitedIntPart = formatNumberGroups(parts[0]);

    return [delimitedIntPart, parts[1]].join('.');
  }

  return formatNumberGroups(num.toFixed(0));
};
